(function () {
    if (!window.webshop || !webshop.webshop || !webshop.webshop.shopping_cart) {
        return;
    }

    var TIMESTAMP_CONFLICT_TEXT = "Document has been modified after you have opened it";
    var QUEUE_POLL_INTERVAL_MS = 500;
    var QUEUE_POLL_TIMEOUT_MS = 30000;
    var QUEUE_MISSING_GRACE_MS = 5000;
    var QUEUE_PROGRESS_HINT_MS = 3000;
    var QUEUE_STATUS_METHOD = "raftor_webhq.checkout.cart_resilience.get_cart_update_status";
    var QUEUE_TIMEOUT_METHOD = "raftor_webhq.checkout.cart_resilience.report_cart_queue_timeout";
    var FLAGS_METHOD = "raftor_webhq.checkout.simple_checkout.get_simple_checkout_flags";

    var QUEUE_PROGRESS_TEXT = "Still updating your cart...";
    var QUEUE_TIMEOUT_TEXT = "Cart update is taking longer than expected. Please refresh to confirm.";
    var LOCAL_QUEUE_PROGRESS_TEXT = "Updating cart...";

    var LOCAL_QUEUE_PREFIX = "cart_ops";
    var LOCAL_QUEUE_META_PREFIX = "cart_ops_meta";
    var LOCAL_QUEUE_TTL_MS = 24 * 60 * 60 * 1000;
    var LOCAL_QUEUE_RETRY_LIMIT = 3;

    var shopping_cart = webshop.webshop.shopping_cart;
    var original_update_cart = shopping_cart.update_cart;
    var original_msgprint = frappe && frappe.msgprint;

    var flagsState = {
        loaded: false,
        loading: false,
        enabled: false,
        version: "v1",
        maxOps: 100,
        lastFetchedAt: 0,
    };
    var localQueueSyncInProgress = false;
    var localQueueCallbacks = {};

    function triggerCartUpdated(payload) {
        if (window.jQuery && typeof window.jQuery === "function") {
            window.jQuery(document).trigger("cart-updated", [payload]);
        }
    }

    function currentUser() {
        return (frappe && frappe.session && frappe.session.user) || "Guest";
    }

    function storageAvailable() {
        try {
            if (!window.localStorage) return false;
            var probe = "__cart_queue_probe__";
            window.localStorage.setItem(probe, "1");
            window.localStorage.removeItem(probe);
            return true;
        } catch (e) {
            return false;
        }
    }

    function logLocalQueueEvent(event, extra) {
        if (!window.console || typeof console.info !== "function") return;
        console.info("[cart-local-queue]", Object.assign({ event: event }, extra || {}));
    }

    function queueScopePrefix() {
        return [LOCAL_QUEUE_PREFIX, window.location.host, currentUser()].join(":") + ":";
    }

    function queueStorageKey(version) {
        return [LOCAL_QUEUE_PREFIX, window.location.host, currentUser(), version].join(":");
    }

    function queueMetaKey() {
        return [LOCAL_QUEUE_META_PREFIX, window.location.host, currentUser()].join(":");
    }

    function clearAllVersionedQueueKeys() {
        if (!storageAvailable()) return;
        var prefix = queueScopePrefix();
        var toRemove = [];
        for (var i = 0; i < window.localStorage.length; i++) {
            var k = window.localStorage.key(i);
            if (k && k.indexOf(prefix) === 0) {
                toRemove.push(k);
            }
        }
        toRemove.forEach(function (k) {
            window.localStorage.removeItem(k);
        });
        window.localStorage.removeItem(queueMetaKey());
    }

    function isGuestUser() {
        return currentUser() === "Guest";
    }

    function loadQueue() {
        if (!storageAvailable()) return [];
        try {
            var raw = window.localStorage.getItem(queueStorageKey(flagsState.version));
            if (!raw) return [];
            var parsed = JSON.parse(raw);
            return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
            return [];
        }
    }

    function saveQueue(ops) {
        if (!storageAvailable()) return;
        try {
            window.localStorage.setItem(queueStorageKey(flagsState.version), JSON.stringify(ops || []));
            window.localStorage.setItem(
                queueMetaKey(),
                JSON.stringify({ version: flagsState.version, updated_at: Date.now() })
            );
        } catch (e) {
            // Ignore storage quota errors; queue becomes best-effort.
        }
    }

    function pruneOps(ops) {
        var nowTs = Date.now();
        var filtered = (ops || []).filter(function (op) {
            return nowTs - (op.created_at || nowTs) <= LOCAL_QUEUE_TTL_MS;
        });

        var maxOps = flagsState.maxOps > 0 ? flagsState.maxOps : 100;
        if (filtered.length > maxOps) {
            filtered = filtered.slice(filtered.length - maxOps);
        }
        return filtered;
    }

    function invalidateIfVersionChanged() {
        if (!storageAvailable()) return;
        try {
            var metaRaw = window.localStorage.getItem(queueMetaKey());
            if (!metaRaw) return;
            var meta = JSON.parse(metaRaw);
            if (!meta || !meta.version || meta.version === flagsState.version) return;
            clearAllVersionedQueueKeys();
            logLocalQueueEvent("local_queue_version_reset", { version: flagsState.version });
        } catch (e) {
            clearAllVersionedQueueKeys();
        }
    }

    function handle_conflict_gracefully() {
        if (window.location.pathname.indexOf("/cart") === 0) {
            window.location.reload();
            return;
        }

        try {
            shopping_cart.set_cart_count(true);
        } catch (e) {
            // Ignore non-critical UI update failures.
        }
    }

    function extract_message_text(msg) {
        if (!msg) return "";
        if (typeof msg === "string") return msg;
        if (typeof msg === "object") {
            return msg.message || msg.msg || msg.title || "";
        }
        return "";
    }

    function show_non_blocking_alert(text, indicator) {
        if (!frappe || typeof frappe.show_alert !== "function") return;
        frappe.show_alert({ message: text, indicator: indicator || "blue" }, 4);
    }

    function notifyQueueTimeout(queueId) {
        frappe.call({
            type: "POST",
            method: QUEUE_TIMEOUT_METHOD,
            args: { queue_id: queueId },
            freeze: false,
        });
    }

    function pollForCartUpdate(queueId, onDone, onFail) {
        var startedAt = Date.now();
        var hintShown = false;

        function poll() {
            var elapsed = Date.now() - startedAt;
            if (!hintShown && elapsed >= QUEUE_PROGRESS_HINT_MS) {
                hintShown = true;
                show_non_blocking_alert(QUEUE_PROGRESS_TEXT, "blue");
            }

            frappe.call({
                type: "GET",
                method: QUEUE_STATUS_METHOD,
                args: { queue_id: queueId },
                callback: function (r) {
                    var message = r && r.message;
                    if (!message) {
                        if (Date.now() - startedAt > QUEUE_POLL_TIMEOUT_MS) {
                            onFail();
                            return;
                        }
                        setTimeout(poll, QUEUE_POLL_INTERVAL_MS);
                        return;
                    }

                    if (message.status === "done") {
                        onDone(message.result || {});
                        return;
                    }

                    if (message.status === "failed") {
                        onFail(message.error);
                        return;
                    }

                    if (message.status === "missing" && elapsed <= QUEUE_MISSING_GRACE_MS) {
                        setTimeout(poll, QUEUE_POLL_INTERVAL_MS);
                        return;
                    }

                    if (elapsed > QUEUE_POLL_TIMEOUT_MS || message.status === "missing") {
                        onFail();
                        return;
                    }
                    setTimeout(poll, QUEUE_POLL_INTERVAL_MS);
                },
                error: function () {
                    if (Date.now() - startedAt > QUEUE_POLL_TIMEOUT_MS) {
                        onFail();
                        return;
                    }
                    setTimeout(poll, QUEUE_POLL_INTERVAL_MS);
                },
            });
        }

        poll();
    }

    function server_update_cart_with_resilience(opts, done) {
        var safe_opts = opts || {};
        var wrapped_opts = Object.assign({}, safe_opts, {
            callback: function (r) {
                var message = r && r.message;

                if (message && message.queued && message.queue_id) {
                    pollForCartUpdate(
                        message.queue_id,
                        function (result) {
                            done({ message: result });
                            triggerCartUpdated(result);
                        },
                        function () {
                            notifyQueueTimeout(message.queue_id);
                            handle_conflict_gracefully();
                            show_non_blocking_alert(QUEUE_TIMEOUT_TEXT, "orange");
                            done({ exc: true, message: { error: QUEUE_TIMEOUT_TEXT } });
                        }
                    );
                    return;
                }

                if (message && message.requires_refresh) {
                    handle_conflict_gracefully();
                    done({ exc: true, message: { error: "Cart requires refresh" } });
                    return;
                }

                done(r || {});
                if (r && !r.exc) {
                    triggerCartUpdated(message);
                }
            },
        });

        return original_update_cart.call(shopping_cart, wrapped_opts);
    }

    function ensureFlags(cb, forceRefresh) {
        if (isGuestUser()) {
            flagsState.enabled = false;
            flagsState.loaded = true;
            flagsState.loading = false;
            clearAllVersionedQueueKeys();
            cb();
            return;
        }

        var shouldUseCache = flagsState.loaded && !forceRefresh && Date.now() - flagsState.lastFetchedAt < 5000;
        if (shouldUseCache) {
            cb();
            return;
        }
        if (flagsState.loading) {
            setTimeout(function () {
                ensureFlags(cb);
            }, 100);
            return;
        }

        flagsState.loading = true;
        frappe.call({
            type: "GET",
            method: FLAGS_METHOD,
            callback: function (r) {
                var flags = (r && r.message) || {};
                flagsState.enabled = !!flags.cart_local_queue_enabled;
                flagsState.version = (flags.cart_local_queue_version || "v1") + "";
                flagsState.maxOps = parseInt(flags.cart_local_queue_max_ops, 10) || 100;
                flagsState.loaded = true;
                flagsState.loading = false;
                flagsState.lastFetchedAt = Date.now();

                if (!flagsState.enabled) {
                    clearAllVersionedQueueKeys();
                    logLocalQueueEvent("local_queue_disabled_by_flag", { reason: "server_flag" });
                } else {
                    invalidateIfVersionChanged();
                    saveQueue(pruneOps(loadQueue()));
                }

                cb();
            },
            error: function () {
                flagsState.loaded = true;
                flagsState.loading = false;
                flagsState.enabled = false;
                flagsState.lastFetchedAt = Date.now();
                cb();
            },
        });
    }

    function maybeStartLocalQueueSync() {
        if (isGuestUser()) {
            clearAllVersionedQueueKeys();
            return;
        }

        if (!flagsState.enabled || !storageAvailable() || localQueueSyncInProgress) {
            return;
        }

        var ops = pruneOps(loadQueue());
        saveQueue(ops);
        if (!ops.length) return;

        localQueueSyncInProgress = true;
        var op = ops[0];

        server_update_cart_with_resilience(
            {
                item_code: op.item_code,
                qty: op.qty,
                additional_notes: op.additional_notes,
                with_items: op.with_items,
            },
            function (r) {
                var refreshed = pruneOps(loadQueue());
                var active = refreshed[0];

                if (!active || active.op_id !== op.op_id) {
                    localQueueSyncInProgress = false;
                    setTimeout(maybeStartLocalQueueSync, 0);
                    return;
                }

                var failed = !r || r.exc;
                if (!failed) {
                    refreshed.shift();
                    saveQueue(refreshed);
                    var cb = localQueueCallbacks[op.op_id];
                    if (typeof cb === "function") cb(r);
                    delete localQueueCallbacks[op.op_id];
                    logLocalQueueEvent("local_queue_synced", { op_id: op.op_id });

                    localQueueSyncInProgress = false;
                    setTimeout(maybeStartLocalQueueSync, 0);
                    return;
                }

                active.attempts = (active.attempts || 0) + 1;
                active.updated_at = Date.now();
                refreshed[0] = active;
                saveQueue(refreshed);

                if (active.attempts >= LOCAL_QUEUE_RETRY_LIMIT) {
                    show_non_blocking_alert(QUEUE_TIMEOUT_TEXT, "orange");
                    handle_conflict_gracefully();
                    var failCb = localQueueCallbacks[op.op_id];
                    if (typeof failCb === "function") failCb({ exc: true, message: { error: QUEUE_TIMEOUT_TEXT } });
                    delete localQueueCallbacks[op.op_id];
                    logLocalQueueEvent("local_queue_retried", {
                        op_id: op.op_id,
                        attempts: active.attempts,
                        status: "paused",
                    });
                    localQueueSyncInProgress = false;
                    return;
                }

                logLocalQueueEvent("local_queue_retried", { op_id: op.op_id, attempts: active.attempts });
                localQueueSyncInProgress = false;
                setTimeout(maybeStartLocalQueueSync, 300 * active.attempts);
            }
        );
    }

    function enqueueLocalOp(opts) {
        var op = {
            op_id: "op_" + Date.now() + "_" + Math.random().toString(16).slice(2),
            item_code: opts.item_code,
            qty: opts.qty,
            additional_notes: opts.additional_notes,
            with_items: opts.with_items || 0,
            attempts: 0,
            created_at: Date.now(),
            updated_at: Date.now(),
        };

        var ops = pruneOps(loadQueue());
        ops.push(op);
        ops = pruneOps(ops);
        saveQueue(ops);

        if (typeof opts.callback === "function") {
            localQueueCallbacks[op.op_id] = opts.callback;
        }

        logLocalQueueEvent("local_queue_enqueued", { op_id: op.op_id, size: ops.length });
        show_non_blocking_alert(LOCAL_QUEUE_PROGRESS_TEXT, "blue");
        maybeStartLocalQueueSync();
    }

    if (typeof original_msgprint === "function") {
        frappe.msgprint = function (msg) {
            var text = extract_message_text(msg);
            if (text && text.indexOf(TIMESTAMP_CONFLICT_TEXT) !== -1) {
                handle_conflict_gracefully();
                return;
            }
            return original_msgprint.apply(this, arguments);
        };
    }

        ensureFlags(function () {
            if (flagsState.enabled) {
                maybeStartLocalQueueSync();
            }
    });

    shopping_cart.update_cart = function (opts) {
        var safe_opts = opts || {};

        if (currentUser() === "Guest") {
            return original_update_cart.call(shopping_cart, safe_opts);
        }

        ensureFlags(function () {
            if (!flagsState.enabled || !storageAvailable()) {
                server_update_cart_with_resilience(safe_opts, function (r) {
                    if (safe_opts.callback) safe_opts.callback(r);
                });
                return;
            }

            enqueueLocalOp(safe_opts);
        }, true);
    };
})();
